import React, { useState, useCallback, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { Props } from './types';
import { login } from '../../../services/sessions';
import { getCsrfToken } from '../../../libs/csrfToken';
import { useFlash } from '../../../hooks/useFlash';

export const Component: FunctionComponent<Props> = ({
  redirectUrl,
  logoPc,
  logoSp,
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { flash, flashType, flashMessage: flashMsg, handleFlash } = useFlash();

  const handleChangeEmail = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setEmail(e.target.value);
    },
    []
  );

  const handleChangePassword = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setPassword(e.target.value);
    },
    []
  );

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    handleFlash(false, '', '');

    try {
      const response = await login(email, password, redirectUrl, getCsrfToken());
      if (response.error_message) {
        handleFlash(true, 'danger', response.error_message);
      } else if (response.redirect_url) {
        window.location.href = response.redirect_url;
      }
    } catch {
      handleFlash(true, 'danger', 'ログインに失敗しました。もう一度お試しください。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Presentation
      email={email}
      password={password}
      flash={flash}
      flashType={flashType}
      flashMessage={flashMsg}
      isSubmitting={isSubmitting}
      logoPc={logoPc}
      logoSp={logoSp}
      onChangeEmail={handleChangeEmail}
      onChangePassword={handleChangePassword}
      onSubmit={handleSubmit}
      handleFlash={handleFlash}
    />
  );
};
